import React from 'react'
import { type Control, useWatch } from 'react-hook-form'
import { cn } from '~/shadcn/lib/utils'
import { GraphIcon } from '~/@mid_ui/icons/GraphIcon'

import { type FormModel } from '../withdraw-funds/schema'

import { useWithdrawFundsInfo } from './useWithdrawFundsInfo'

type Props = { control: Control<FormModel> }

function formatAmount(value: number) {
  return new Intl.NumberFormat('sk-SK', {
    currency: 'EUR',
    style: 'currency',
  }).format(value)
}

export function WithdrawFundsInfo({ control }: Props) {
  const amount = useWatch({ control, name: 'amount' })
  const { companyIban } = useWithdrawFundsInfo()

  return (
    <div
      className={cn(
        'flex flex-col gap-5 p-5 w-full border border-[#006EF0] rounded-lg'
      )}>
      <div className="flex justify-between items-center">
        <div className="font-semibold">Zhrnutie</div>
        <GraphIcon />
      </div>
      <div className="flex flex-col">
        <div className="flex gap-3 items-center">
          <ItemTitle>odkiaľ vyberáte</ItemTitle>
          <ItemContent>Investičný účet</ItemContent>
        </div>
        <div className="flex gap-3 items-center">
          <ItemTitle>číslo bankového účtu</ItemTitle>
          <ItemContent>{companyIban}</ItemContent>
        </div>
      </div>
      <div className="flex gap-3 items-center">
        <ItemTitle>čiastka</ItemTitle>
        <ItemContent className="text-[#006EF0]" translate="no">
          {Number.isNaN(amount) || !amount ? `0 €` : formatAmount(amount)}
        </ItemContent>
      </div>
    </div>
  )
}

function ItemTitle({
  className,
  children,
  ...props
}: React.ComponentProps<'div'>) {
  return (
    <div
      className={cn(
        'text-border text-sm font-semibold leading-[21px] w-[200px] uppercase',
        className
      )}
      {...props}>
      {children}
    </div>
  )
}

function ItemContent({
  className,
  children,
  ...props
}: React.ComponentProps<'div'>) {
  return (
    <div
      className={cn('text-base font-semibold leading-[26px]', className)}
      {...props}>
      {children}
    </div>
  )
}
